import React from "react";
import ProductList from "../components/ProductList";
import AffiliateLinks from "../components/AffiliateLinks";
import Cart from "../components/Cart";
import SignupModal from "../components/SignupModal";
import DealGrid from "../components/DealGrid";

const Home = () => {
  return (
    <>
      <div className="container">
        <AffiliateLinks />
        { /*<ProductList />*/ }
      </div>

      <SignupModal />
    </>
  );
};

export default Home;
